import { Injectable } from '@kaokei/use-vue-service';
import { DaoService } from './dao.service';

import { HomeBanner, NavBarList, UserCreationList } from '@/types';
import { SHOW_BRAND } from '@/utils';

@Injectable()
export class HomeService {
  public banner: HomeBanner[] = [];
  public navBarList: NavBarList = [];
  public userCreationList: UserCreationList = [];

  constructor(public daoService: DaoService) {}

  public getBanner() {
    return this.daoService.getHomeBanner().then(banner => {
      this.banner = banner;
    });
  }

  public getNavBarList() {
    return this.daoService
      .getHomeNavBar({
        activityTypeList: '1,3',
        showBrand: SHOW_BRAND,
      })
      .then(navBarList => {
        this.navBarList = navBarList
          // .filter(item => [1, 3].includes(item.activityTypeCode))
          .map(item => {
            item.contestSummaryList.forEach(sub => {
              sub.activityTypeCode = item.activityTypeCode;
              sub.activityTypeName = item.activityTypeName;
            });
            return item;
          });
      });
  }

  public getUserCreationList() {
    return this.daoService.getUserCreationList(1, 12).then(res => {
      this.userCreationList = res.list;
    });
  }
}
